module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "timeline__hoverable"
  }, [_c('header', {
    staticClass: "timeline__header timeline__highlightable"
  }, [_c('h3', {
    staticClass: "timeline__title"
  }, [_vm._v("\n            " + _vm._s(_vm.assignment.title) + "\n            "), (_vm.hasFeedback) ? _c('span', {
    staticClass: "icon icon--inline icon--feedback",
    class: {
      'icon--feedback-dark': _vm.isActive
    },
    attrs: {
      "title": "Heeft feedback gekregen"
    }
  }) : _vm._e(), (_vm.shouldRetake) ? _c('span', {
    staticClass: "icon icon--inline icon--retake",
    class: {
      'icon--retake-dark': _vm.isActive
    },
    attrs: {
      "title": "Opdracht opnieuw inleveren"
    }
  }) : _vm._e(), (_vm.hasDiligence) ? _c('span', {
    staticClass: "diligence__icon diligence__icon--bg-replace diligence__icon--mini active",
    class: 'diligence__icon--' + _vm.diligence.tag,
    attrs: {
      "title": _vm.diligence.tag
    }
  }) : _vm._e()]), _c('span', {
    staticClass: "timeline__meta"
  }, [_c('span', {
    staticClass: "timeline__date"
  }, [_vm._v(_vm._s(_vm.date))]), (!_vm.progress.finished) ? _c('span', {
    staticClass: "timeline__progress"
  }, [_vm._v(" - stap " + _vm._s(_vm.progress.step + 1))]) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "reveal"
    }
  }, [(_vm.preview) ? _c('p', {
    staticClass: "timeline__content timeline__content--submission"
  }, [(_vm.type == 'Image') ? _c('img', {
    staticClass: "timeline__thumbnail",
    attrs: {
      "src": _vm.preview.data.thumb
    }
  }) : _vm._e(), (_vm.type == 'Text') ? _c('span', {
    staticClass: "timeline__text"
  }, [_vm._v("“" + _vm._s(_vm.previewText) + "”")]) : _vm._e(), (_vm.hasBadge) ? _c('img', {
    staticClass: "timeline__badge",
    class: {
      'timeline__badge--right': _vm.type == 'Text'
    },
    attrs: {
      "src": ("/build/img/badges/badge-" + (_vm.badge.type) + "-color-128x.png")
    }
  }) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3ce445e","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/Assignment.vue
// module id = UUci
// module chunks = 1